import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../../../common/_common.scss'
import AdviserProfileEducation from '../../../../../common/AdviserProfiles/AdviserProfileEducation'
import EditButton from '../../../../../common/forms/EditButton'
import DeleteButton from '../../../../../common/forms/DeleteButton'
import AdviserQualificationEditor from './AdviserQualificationEditor'
import * as styles from './_PendingApprovalAdviserProfileEducationEditor.scss'
import { Modal } from 'react-bootstrap'
import PrimaryActionButton from '../../../../../common/Buttons/PrimaryActionButton'
import SecondaryActionButton from '../../../../../common/Buttons/SecondaryActionButton'
import { modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  setAddNewQualification
  , setStartEditingQualification
  , setStopEditingQualification
  , setCancelEditingQualification
  , setQualification
  , setQualificationStudyStartMonth
  , setQualificationStudyStartYear
  , setQualificationStudyEndMonth
  , setQualificationStudyEndYear
  , setQualificationStudyEndDateCurrent
  , setDeleteQualificationModal
  , setDeletingQualification
  , setDeletedQualification
  , deleteQualification
  , setDeletingQualificationCancel
} from './pendingApprovalAdviserProfileEducationEditorActions'

class adviserProfileEducationEditor extends React.Component {
  static propTypes = {
    pendingApprovalProfile: PropTypes.object.isRequired,
    publishedProfile: PropTypes.object.isRequired,
    validationstate: PropTypes.object.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    editingProfile: PropTypes.bool.isRequired,

    setAddNewQualification: PropTypes.func.isRequired,
    setStartEditingQualification: PropTypes.func.isRequired,
    setStopEditingQualification: PropTypes.func.isRequired,
    setCancelEditingQualification: PropTypes.func.isRequired,
    setQualification: PropTypes.func.isRequired,
    setQualificationStudyStartMonth: PropTypes.func.isRequired,
    setQualificationStudyStartYear: PropTypes.func.isRequired,
    setQualificationStudyEndMonth: PropTypes.func.isRequired,
    setQualificationStudyEndYear: PropTypes.func.isRequired,
    setQualificationStudyEndDateCurrent: PropTypes.func.isRequired,
    setDeleteQualificationModal: PropTypes.func.isRequired,
    deleteQualification: PropTypes.func.isRequired,
    setDeletingQualification: PropTypes.func.isRequired,
    setDeletedQualification: PropTypes.func.isRequired,
    setDeletingQualificationCancel: PropTypes.func.isRequired,
    qualificationsModifications: PropTypes.array.isRequired,

    loadingEducation: PropTypes.bool.isRequired,
    editingQualification: PropTypes.bool.isRequired,
    editingQualificationIndex: PropTypes.number.isRequired,
    deletingQualification: PropTypes.bool.isRequired,
    deletingQualificationModal: PropTypes.bool.isRequired,
    deletingQualificationIndex: PropTypes.number.isRequired,
    studyStartMonth: PropTypes.number,
    studyStartYear: PropTypes.number,
    studyEndMonth: PropTypes.number,
    studyEndYear: PropTypes.number
  };

  componentDidMount () {
    this.setState({})
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.deletingQualification && this.props.deletingQualification) {
      this.props.setDeletedQualification()
    }
  }

  renderPreview () {
    const editDeleteButtons = (index) => {
      return <span key={index}>
        <EditButton
          editing={this.props.editingQualification}
          startEditing={() => {
            this.props.setStartEditingQualification(index)
          }} />
        |
        <DeleteButton
          startDeleting={() => {
            this.props.setDeleteQualificationModal(index)
          }} />
      </span>
    }

    const children = this.props.qualificationsModifications.map((qualification, index) => {
      if (qualification.modificationState === modificationStates.deleted) {
        return <span key={index} />
      } else {
        return editDeleteButtons(index)
      }
    })

    return <div className={styles['form-bottom-margin'] + ' modal-container'}>
      <AdviserProfileEducation qualifications={this.props.qualificationsModifications} className={styles['no-bottom-padding']} comparison hideDeleted={this.props.editingProfile} >
        {this.props.editingProfile && children ? children : null}
      </AdviserProfileEducation>
      {this.props.editingProfile &&
        <a className={styles['add-education-button']} onClick={() => {
          this.props.setAddNewQualification()
        }} target='blank'>Add a qualification to your profile</a>}
      <Modal
        show={this.props.deletingQualificationModal}
        aria-labelledby='contained-modal-title' >
        <Modal.Header style={{ borderBottom: 'none', paddingLeft: '40px', paddingRight: '40px', paddingTop: '40px' }}>
          <h2>Deleting qualification</h2>
        </Modal.Header>
        <Modal.Body style={{ paddingLeft: '40px', paddingRight: '40px' }}>
          <p>Are you sure you wish to delete the {this.props.deletingQualificationIndex !== -1 ? this.props.qualificationsModifications[this.props.deletingQualificationIndex].description : ''}?</p>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '40px' }}>
          <PrimaryActionButton
            className={commonStyles['delete-confirmation-modal-button']}
            buttonText='Delete'
            onClick={() => {
              this.props.deleteQualification()
            }}
          />
          <SecondaryActionButton
            buttonText='Cancel'
            onClick={() => {
              this.props.setDeletingQualificationCancel()
            }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  }

  renderEditor () {
    return <AdviserProfileEducation qualifications={this.props.qualificationsModifications} editor editingIndex={this.props.editingQualificationIndex} hideDeleted className={styles['no-bottom-padding']} >
      {this.props.qualificationsModifications.map((qualification, index) => {
        if (this.props.editingQualificationIndex === index) {
          return <AdviserQualificationEditor
            key={index}
            formIsValid={this.props.formIsValid}
            qualification={qualification}
            editingQualification={this.props.editingQualification}
             validationstate={this.props.validationstate}
            stopEditingQualification={() => {
              this.props.setStopEditingQualification()
            }}
            cancelEditingQualification={() => {
              this.props.setCancelEditingQualification()
            }}
            descriptionHandleChange={(validationResult, value) => {
              this.props.setQualification(validationResult, {
                description: value,
                institution: qualification.institution,
                studyEndDate: qualification.studyEndDate,
                studyStartDate: qualification.studyStartDate,
                modificationState: qualification.modificationState
              })
            }}
            institutionHandleChange={(validationResult, value) => {
              this.props.setQualification(validationResult, {
                description: qualification.description,
                institution: value,
                studyEndDate: qualification.studyEndDate,
                studyStartDate: qualification.studyStartDate,
                modificationState: qualification.modificationState
              })
            }}
            dateHandleChange={() => {
              let validationResult = {
                description: this.props.validationstate.description,
                institution: this.props.validationstate.institution
              }
              this.props.setQualification(validationResult, {
                description: qualification.description,
                institution: qualification.institution,
                studyStartDate: qualification.studyStartDate,
                studyEndDate: qualification.studyEndDate,
                modificationState: qualification.modificationState
              })
            }}
            studyStartMonth={this.props.studyStartMonth}
            studyStartYear={parseInt(this.props.studyStartYear)}
            studyEndMonth={this.props.studyEndMonth}
            studyEndYear={parseInt(this.props.studyEndYear)}
            handleStudyStartMonth={(validationResult, value) => {
              this.props.setQualificationStudyStartMonth(validationResult, value)
            }}
            handleStudyStartYear={(validationResult, value) => {
              this.props.setQualificationStudyStartYear(validationResult, value)
            }}
            handleStudyEndMonth={(validationResult, value) => {
              this.props.setQualificationStudyEndMonth(validationResult, value)
            }}
            handleStudyEndYear={(validationResult, value) => {
              this.props.setQualificationStudyEndYear(validationResult, value)
            }}
            handleCurrentEndYear={() => {
              this.props.setQualificationStudyEndDateCurrent()
            }}
            handleSubmit={() => {
              this.props.setStopEditingQualification()
            }}
          />
        }
      })}
    </AdviserProfileEducation>
  }

  render () {
    if (this.props.editingQualification) {
      return this.renderEditor()
    }

    return this.renderPreview()
  }
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    loadingEducation: adviserProfileApprovalEditorContainer.education.loadingEducation,
    editingQualification: adviserProfileApprovalEditorContainer.education.editingQualification,
    editingQualificationIndex: adviserProfileApprovalEditorContainer.education.editingQualificationIndex,
    deletingQualification: adviserProfileApprovalEditorContainer.education.deletingQualification,
    deletingQualificationModal: adviserProfileApprovalEditorContainer.education.deletingQualificationModal,
    deletingQualificationIndex: adviserProfileApprovalEditorContainer.education.deletingQualificationIndex,
    studyStartMonth: adviserProfileApprovalEditorContainer.education.studyStartMonth,
    studyEndMonth: adviserProfileApprovalEditorContainer.education.studyEndMonth,
    studyStartYear: adviserProfileApprovalEditorContainer.education.studyStartYear,
    studyEndYear: adviserProfileApprovalEditorContainer.education.studyEndYear,
    formIsValid: adviserProfileApprovalEditorContainer.education.isInvalid.formIsValid,
    validationstate: adviserProfileApprovalEditorContainer.education.isInvalid,
    allEducation: adviserProfileApprovalEditorContainer.education.allEducation,
    qualificationsModifications: adviserProfileApprovalEditorContainer.education.qualificationsModifications,
    editingProfile: adviserProfileApprovalEditorContainer.editingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setAddNewQualification: setAddNewQualification,
    setStartEditingQualification: setStartEditingQualification,
    setStopEditingQualification: setStopEditingQualification,
    setCancelEditingQualification: setCancelEditingQualification,
    setQualification: setQualification,
    setQualificationStudyStartMonth: setQualificationStudyStartMonth,
    setQualificationStudyStartYear: setQualificationStudyStartYear,
    setQualificationStudyEndMonth: setQualificationStudyEndMonth,
    setQualificationStudyEndYear: setQualificationStudyEndYear,
    setQualificationStudyEndDateCurrent: setQualificationStudyEndDateCurrent,
    setDeleteQualificationModal: setDeleteQualificationModal,
    deleteQualification: deleteQualification,
    setDeletingQualification: setDeletingQualification,
    setDeletedQualification: setDeletedQualification,
    setDeletingQualificationCancel: setDeletingQualificationCancel
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileEducationEditor))
